import { useState, useEffect } from "react"
import { useRouter } from "next/router"
import getTelLink from "utilities/getTelLink"
import Phone from "public/assets/phone.svg"
import MailIcon from "public/assets/mail-icon.svg"
import Messenger from "public/assets/messenger.svg"
import MapPin from "public/assets/map-pin.svg"
import { useDogtownLocations } from "context/dogtownLocations"

export default function InfoBox() {
  const locations = useDogtownLocations()
  const router = useRouter()

  const [currentLocation, setCurrentLocation] = useState({
    address: "",
    mapsLink: "",
    phone: "",
    email: "",
    messenger: "",
  })

  useEffect(() => {
    locations.pins.map((location) => {
      if (router.asPath.includes(location.slug.endsWith("/") ? location.slug.slice(0, -1) : location.slug)) {
        setCurrentLocation(location)
      }
    })
  }, [router, locations])

  const iconLink =
    "text-white flex items-center gap-4 text-s3 not-italic underline hover:no-underline font-bold leading-[22px]"

  return (
    <address className="hidden lg:flex bg-gray-dark py-4 px-8 divide-x-2 xl:absolute w-full -bottom-8">
      <a
        href={currentLocation.mapsLink ?? "#"}
        className={iconLink}
        target={currentLocation.mapsLink ? "_blank" : "_self"}
        rel="noreferrer"
      >
        <MapPin className="w-8 text-white" />
        {currentLocation.address}
      </a>
      <div className="pl-5 flex flex-col gap-4 basis-1/2">
        <a href={getTelLink(currentLocation.phone.primary) ?? "#"} className={iconLink}>
          <Phone className="w-6 text-white" />
          {currentLocation.phone.primary}
        </a>
        <a href={currentLocation.messenger ?? "#"} className={iconLink}>
          <Messenger className="w-6 text-white" />
          Message Us
        </a>
        <a href={`mailto:${currentLocation.email.frontDesk}` ?? "#"} className={iconLink}>
          <MailIcon className="w-6 text-white" />
          Email Us
        </a>
      </div>
    </address>
  )
}
